import IconAsButton from "src/components/IconAsButton";
import { ReactComponent as CloseIcon } from "./close.svg";

export default function CloseButton({
  fill,
  absolute = false,
  size = "20px",
  onClick,
  ...rest
}) {
  return (
    <IconAsButton
      size={size}
      onClick={onClick}
      fill={fill}
      icon={CloseIcon}
      position={absolute ? "absolute" : "static"}
      top={absolute ? "14px" : "0"}
      right={absolute ? "20px" : "0"}
      zIndex={absolute ? 100 : "auto"}
      {...rest}
    />
  );
}
